import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { select, Store } from "@ngrx/store";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { RoleEnum } from "src/app/shared/models/user/role.interface";
import { JwtService } from "src/app/shared/services/jwt.service";
import { AppStateInterface } from "src/app/store/appState.interface";
import { invokeFranchisesCompanyNames } from "src/app/store/franchise/franchise.action";
import { franchisesComapyNamesSelector } from "src/app/store/franchise/franchise.selectors";

@Component({
  selector: "app-personal-information",
  templateUrl: "./personal-information.component.html",
})
export class PersonalInformationComponent extends BaseComponent implements OnInit {
  showPassword1: boolean = false;
  showConfirmPassword1: boolean = false;
  @Input() isEmailCheck: boolean = false;
  @Input() isFranchised: boolean = false;
  isAdminLoggedIn: boolean = false;
  
  allFranchisesCompanyNames$: Observable<string[] | null>;
  resultAllFranchisesCompanyNames: string[] | null;


  showPassword() {
    this.showPassword1 = !this.showPassword1;
  }
  showConfirmPassword() {
    this.showConfirmPassword1 = !this.showConfirmPassword1;
  }
  @Input("form") form: FormGroup;

  constructor(
    private store: Store<AppStateInterface>,
    private jwtService: JwtService
  ) {
    super(store);

    this.isAdminLoggedIn = this.jwtService.getRoleName(localStorage.getItem("token"))  === RoleEnum.ROLE_ADMIN;
    this.allFranchisesCompanyNames$ = this.store
      .pipe(select(franchisesComapyNamesSelector))
      .pipe(takeUntil(this.ngDestroyed$));
  }
  ngOnInit(): void {
    if (this.isAdminLoggedIn && this.isFranchised) {
      this.store.dispatch(invokeFranchisesCompanyNames());
      this.allFranchisesCompanyNames$.subscribe((data) => {
        if (data) {
          this.resultAllFranchisesCompanyNames = data;
        }
      });
    }
  }
}
